// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__1VP4G","heading__form":"Heading_heading__form__3vIiu","heading__view":"Heading_heading__view__2jnFJ"};